import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CircularProgress, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReportCard from "components/ReportCard";
import { OEEGauge } from "components/OEEGauge";
import { toMetricPercent } from "utilities/oeeSummary";
import { useStyles } from "./OeeGaugeCard.styles";
import { IOeeGaugeCardProps } from "./OeeGaugeCardInterfaces";

/**
 * Headline gauge. The title never names the selected production line: like the overview cards of the downtime
 * Summary report, the selection shows in the line list beside it, and a line name would wrap in the narrow column.
 */
const OeeGaugeCard = ({ loading, metric, value }: IOeeGaugeCardProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <ReportCard
            className={classes.card}
            title={t(`locations.oee_summary_dashboard.gauges.${metric}`)}
            headerActions={
                <Tooltip title={t(`locations.oee_summary_dashboard.tooltips.${metric}`)} placement="top">
                    <InfoOutlinedIcon
                        aria-hidden={false}
                        className={classes.infoIcon}
                        fontSize="small"
                        role="img"
                        tabIndex={0}
                    />
                </Tooltip>
            }
        >
            <div className={classes.body}>
                {loading ? (
                    <CircularProgress size={24} color="info" />
                ) : (
                    <div className={classes.gauge}>
                        <OEEGauge percentage={toMetricPercent(value, metric)} />
                    </div>
                )}
            </div>
        </ReportCard>
    );
};

export default OeeGaugeCard;
